module.exports = __webpack_public_path__ + "static/calendar_wireframe-8dd5234b26d4e1c804ed46b8e15d8b6f.svg";